export default "__VITE_ASSET__CZmKnrdr__"